module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/book-details/book_detail_05-c65816a79783ea793c0f3eb6a3fe01b7.png";